import { render } from "./PrimaryLink.vue?vue&type=template&id=204de146"
import script from "./PrimaryLink.vue?vue&type=script&lang=js"
export * from "./PrimaryLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__